import {
  Discovery,
  DiscoveryFilter,
} from '../../../../../store/features/discovery';
import { FacetType, SiteFacetTypes } from '../../../../../types';
import {
  FACET_TYPE_ORDER,
  HEADING_MAP,
  MAX_FILTER_TO_SHOW_COUNT_MAP,
  ZERO_COUNT_FACETS_HIDDEN_LIST,
} from '../../constants';
import { FilterFacetGroup, Checkbox, Radio } from '../../components';

export interface FilterFacetsProps {
  facets: Discovery['facets'];
}

export function sortByTypeOrder(order: string[]) {
  return function (a: DiscoveryFilter, b: DiscoveryFilter) {
    const aIndex = order.indexOf(a.label);
    const bIndex = order.indexOf(b.label);

    if (aIndex > bIndex) {
      return 1;
    } else if (aIndex < bIndex) {
      return -1;
    }

    return 0;
  };
}

export function sortByFacetTypeOrder(a: FacetType, b: FacetType) {
  const aIndex = FACET_TYPE_ORDER.indexOf(a);
  const bIndex = FACET_TYPE_ORDER.indexOf(b);

  if (aIndex > bIndex) {
    return 1;
  } else if (aIndex < bIndex) {
    return -1;
  }

  return 0;
}

export function sortByFacetType(
  facetType: FacetType,
  filters: DiscoveryFilter[],
): DiscoveryFilter[] {
  return filters;
}

const filterNonZeroFilters = (
  facets: DiscoveryFilter[],
  facetName: FacetType,
) =>
  facets.filter((facet) => {
    if (!facet.label) {
      return false;
    }

    if (ZERO_COUNT_FACETS_HIDDEN_LIST.includes(facetName)) {
      return facet.count > 0;
    }

    return true;
  });

export function FilterFacets({ facets }: FilterFacetsProps) {
  const facetTypes = Object.keys(facets) as [SiteFacetTypes];
  const sortedByOrderFacetTypes = [...facetTypes].sort(sortByFacetTypeOrder);

  return (
    <>
      {sortedByOrderFacetTypes
        .filter((facetType) => facets[facetType].length > 0)
        .map((facetType) => {
          const zeroFilter = facets[facetType][0];
          const inputType = zeroFilter.type === 'ALL' ? 'radio' : 'checkbox';
          const inputName = zeroFilter.filterValue.type;
          const filters = filterNonZeroFilters(facets[facetType], facetType);
          const sortedFilters = sortByFacetType(facetType, filters);

          return (
            filters.length > 0 && (
              <FilterFacetGroup
                key={facetType}
                type={inputType}
                name={inputName}
                filters={sortedFilters}
                maxFiltersToShowCount={MAX_FILTER_TO_SHOW_COUNT_MAP[facetType]}
                heading={HEADING_MAP[facetType]}
                renderFilterItem={(filter, type) => (
                  <>
                    {type === 'radio' && <Radio data={filter} />}
                    {type === 'checkbox' && <Checkbox data={filter} />}
                  </>
                )}
              />
            )
          );
        })}
    </>
  );
}
